module.exports = __webpack_public_path__ + "img/slider-horizontal.4cc37932.svg";